import DiscountTypeImportPage from './DiscountTypeImportPage';

export default DiscountTypeImportPage;
